export const users_per_day = 800;
export const tuesdaySaleDay = 2;
export const base_users_value = 15000;
export const users_per_10_min = users_per_day / (24 * 6);
export const base_date_tuesday = new Date('2023-04-12T00:00:00.000Z');

export const getNumberOfTuesdays = (date_future, date_now) => {
  const msInDay = 86400000;
  const dayCount = (date_future - date_now) / msInDay + 1; // Plus one to make inclusive of start and end date
  const completeWeeks = Math.floor(dayCount / 7);
  const extraDays = dayCount % 7;
  const dayNumber = tuesdaySaleDay;
  const firstExtraDay = date_now.getDay();
  const lastExtraDay = (date_now.getDay() + extraDays - 1) % 7;
  const isExtraDay =
    (dayNumber >= firstExtraDay && dayNumber <= lastExtraDay) ||
    dayNumber <= lastExtraDay - 7;

  let days = completeWeeks;
  if (extraDays > 0 && isExtraDay) {
    days++;
  }
  const hour = date_future.getHours();
  let minutes = hour * 60 + date_future.getMinutes();
  return { days, minutes };
};

export const getTotalUsers = (days, minutes) => {
  const users =
    days === 0
      ? parseInt(minutes / 10) * users_per_10_min
      : days * users_per_day + parseInt(minutes / 10) * users_per_10_min;
  return base_users_value + Math.floor(users);
};
export const liveCountTextTuesday =
  'Customers have availed the offer and counting.';
